import { render, staticRenderFns } from "./a-list.vue?vue&type=template&id=3814cf24&scoped=true&"
import script from "./a-list.vue?vue&type=script&lang=js&"
export * from "./a-list.vue?vue&type=script&lang=js&"
import style0 from "./a-list.vue?vue&type=style&index=0&id=3814cf24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3814cf24",
  null
  
)

export default component.exports